import { SET_STORY_EDITOR_CHAT } from 'admin/constants/actions';

export type SetStoryEditorChatPayload = {
	open: boolean;
};

export function setStoryEditorChat(payload: SetStoryEditorChatPayload) {
	return { type: SET_STORY_EDITOR_CHAT, payload };
}
